import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';
import '../css/loading.styles.css'

// const useStyles = makeStyles({
//   root: {
//     width: 300,
//   },
// });

export default function Animations() {
    //const classes = useStyles();
    return (
        <div className="col-12 col-md-6 col-lg-5 col-xl-4">
            <div className="hvs">
                <div className="emp-details">

                    <div className="uesr-details">
                        <div className="action-btn">
                            {/* <button className="mdl-js-button mdl-js-ripple-effect" data-toggle="tooltip" title="Edit Profile" id="edtemp"><i className="edit">Edit</i></button>
                            <button className="mdl-js-button mdl-js-ripple-effect" data-toggle="modal"><i className="delete">Delete</i></button> */}
                        </div>

                        <div className="profile-pic" >
                            <Skeleton className="loading-basic-img" variant="circle" />

                        </div>
                        <div className="profile-name" style={{width:"300px"}}>
                           <Skeleton className="loading-basic-p" variant="text" animation="wave" />
                        </div>



                        <div className="kyctype">
                            <Skeleton className="loading-basic-p" variant="text" animation="wave" />
                        </div>
                    </div>

                    <div className="uesr-details" id="uesr-details">
                        <ul>
                            <li><i className="email"></i> <Skeleton className="loading-basic-p" variant="text" animation="wave" /></li>
                            <li><i className="calendar"></i><Skeleton className="loading-basic-p" variant="text" animation="wave" /></li>
                            <li><i className="gender"></i> <Skeleton className="loading-basic-p" variant="text" animation="wave" /></li>
                            <li><i className="location"></i> <Skeleton className="loading-basic-p" variant="text" animation="wave" /></li>
                        </ul>
                    </div>

                    <div className="pro-details" id="pro-details" >
                        <div className="pro-id"><span>Employee ID:</span> <Skeleton className="loading-basic-p" variant="text" animation="wave" /></div>
                        <div className="pro-id"><span>Date of Joining:</span>  <Skeleton className="loading-basic-p" variant="text" animation="wave" /></div>
                        <div className="pro-id"><span>Department:</span>  <Skeleton className="loading-basic-p" variant="text" animation="wave" /></div>
                        <div className="pro-id"><span>Band:</span>  <Skeleton className="loading-basic-p" variant="text" animation="wave" /></div>
                        <div className="pro-id"><span>Reporting Manager ID:</span>  <Skeleton className="loading-basic-p" variant="text" animation="wave" /></div>
                        <div className="pro-id"><span>Finance Manager ID:</span>  <Skeleton className="loading-basic-p" variant="text" animation="wave" /></div>
                        <div className="pro-id"><span>PAN:</span>  <Skeleton className="loading-basic-p" variant="text" animation="wave" /></div>
                        <div className="pro-id"><span>Aadhaar Number:</span>  <Skeleton className="loading-basic-p" variant="text" animation="wave" /></div>
                    </div>





                    <div className="assign-role">
                        <label>Assigned Role</label>
                        <div className="input-group">
                            <select className="form-control">

                            </select>
                            <div className="input-group-append">
                                <button type="button" className="btn btnbl" id="">Ok</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}